import React from 'react';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="d-flex flex-row justify-content-between">
                <div>
                    <span>&copy; 2019 BG BAU - Berufsgenossenschaft der Bauwirtschaft</span>
                </div>
                <div>
                    <Button
                        color="link"
                        href="https://www.bgbau.de/impressum/"
                        target="_blank"
                        size="sm"
                        className="text-uppercase"
                    >
                        Impressum
                    </Button>
                </div>
            </div>
        </footer>
    );
};
export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js